module.exports = __webpack_public_path__ + "img/Flag_of_the_Pitcairn_Islands.f33a06a9.svg";